// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   UserSignup 2026 — Figma node 2034:12383 기반 신규 디자인
   모바일 360px 단일 컬럼, login2026 시스템과 동일한 토큰 사용
   ============================================================ */

.signup2026 {
    min-height: 100vh;
    background: #fff;
    font-family: var(--font-sans, 'Pretendard', sans-serif);
    color: var(--fg-text-basic);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px 24px 32px;
    box-sizing: border-box;
}

.signup2026__main {
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 24px;
    flex: 1 1;
}

/* 약관 동의 단계: 폼을 화면 세로 중앙에 배치 */
.signup2026--centered {
    justify-content: center;
}

.signup2026--centered .signup2026__main {
    flex: 0 1 auto;
}

.signup2026__form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

/* ─── 섹션 공통 ─── */
.signup2026__section {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.signup2026__section--complete {
    gap: 20px;
    align-items: stretch;
}

/* ─── 브랜드 로고 + 워드마크 ─── */
.signup2026__brand {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 42px;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    transition: opacity var(--transition-fast, 0.15s ease);
}

.signup2026__brand:hover {
    opacity: 0.85;
}

.signup2026__brand-logo {
    width: 38px;
    height: 42px;
    object-fit: contain;
    display: block;
}

.signup2026__brand-text {
    font-family: 'Pretendard', sans-serif;
    font-size: 26px;
    font-weight: 800;
    color: var(--fg-text-basic);
    letter-spacing: -0.6px;
    line-height: 1;
}

/* ─── 섹션 타이틀 ─── */
.signup2026__title {
    margin: 0;
    font-size: 28px;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.2px;
    color: var(--fg-text-basic);
}

.signup2026__subtitle {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    color: var(--fg-text-basic);
}

/* ─── 필드 ─── */
.signup2026__field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
}

.signup2026__field--compact {
    gap: 4px;
}

.signup2026__field-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    color: var(--fg-text-basic);
}

.signup2026__field-label svg {
    flex-shrink: 0;
}

.signup2026__input {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 12px;
    background: #fff;
    border: 1px solid var(--fg-line);
    border-radius: 8px;
    font-family: inherit;
    font-size: 16px;
    line-height: 26px;
    color: var(--fg-text-basic);
    outline: none;
    transition: border-color 160ms ease;
}

.signup2026__input::placeholder {
    color: var(--fg-text-gray);
}

.signup2026__input:focus {
    border-color: var(--fg-button);
}

.signup2026__input:disabled {
    background: #fafafa;
    color: var(--fg-text-gray);
    cursor: not-allowed;
}

.signup2026__input--error {
    border-color: var(--fg-anti-red, #ff1500);
}

.signup2026__field-error {
    margin: 0;
    font-size: 14px;
    line-height: 1.2;
    color: var(--fg-anti-red, #ff1500);
}

.signup2026__field-hint {
    margin: 0;
    font-size: 13px;
    line-height: 1.2;
    color: var(--fg-text-gray);
}

.signup2026__field-hint--ok {
    color: var(--fg-button-hover);
}

/* ─── 셀렉트 ─── */
.signup2026__select-wrap {
    position: relative;
    width: 100%;
}

.signup2026__select {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 36px 8px 12px;
    background: #fff;
    border: 1px solid var(--fg-line);
    border-radius: 8px;
    font-family: inherit;
    font-size: 16px;
    line-height: 26px;
    color: var(--fg-text-basic);
    outline: none;
    appearance: none;
    cursor: pointer;
    transition: border-color 160ms ease;
}

.signup2026__select--placeholder {
    color: var(--fg-text-gray);
}

.signup2026__select:focus {
    border-color: var(--fg-button);
}

.signup2026__select-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    pointer-events: none;
}

/* ─── 성별 / 내외국인 토글 그룹 ─── */
.signup2026__toggle-row {
    display: flex;
    gap: 12px;
    width: 100%;
}

.signup2026__toggle-group {
    display: flex;
    gap: 4px;
    flex: 1 1;
    min-width: 0;
}

.signup2026__toggle {
    flex: 1 1;
    min-width: 0;
    padding: 8px;
    background: #fff;
    border: 1px solid var(--fg-line);
    border-radius: 8px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 500;
    color: var(--fg-text-gray);
    cursor: pointer;
    transition: border-color 160ms ease, color 160ms ease, background 160ms ease;
}

.signup2026__toggle:hover:not(:disabled) {
    border-color: var(--fg-text-basic);
}

.signup2026__toggle--active {
    border-color: var(--fg-text-basic);
    color: var(--fg-text-basic);
    font-weight: 600;
}

/* ─── 약관 동의 박스 ─── */
.signup2026__terms-box {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    padding: 0;
    background: #fff;
}

.signup2026__check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-shrink: 0;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.signup2026__check input {
    position: absolute;
    opacity: 0;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
}

.signup2026__check-box {
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 2px solid var(--fg-text-gray);
    border-radius: 50%;
    transition: background 160ms ease, border-color 160ms ease;
    box-sizing: border-box;
}

.signup2026__check-box svg {
    opacity: 0;
    transition: opacity 160ms ease;
}

.signup2026__check input:checked + .signup2026__check-box {
    background: var(--fg-button);
    border-color: var(--fg-button);
}

.signup2026__check input:checked + .signup2026__check-box svg {
    opacity: 1;
}

.signup2026__terms-content {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 6px;
}

.signup2026__terms-title {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: var(--fg-text-basic);
    line-height: 1;
}

.signup2026__terms-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: auto;
}

.signup2026__terms-list button {
    background: transparent;
    border: 0;
    padding: 0;
    width: auto;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: inherit;
    font-size: 14px;
    line-height: 1.2;
    color: var(--fg-text-gray);
    cursor: pointer;
    transition: color 160ms ease;
    white-space: nowrap;
}

.signup2026__terms-list button > span {
    white-space: nowrap;
}

.signup2026__terms-list button:hover {
    color: var(--fg-text-basic);
}

.signup2026__terms-list button svg {
    flex-shrink: 0;
}

/* ─── 인증번호 입력 행 ─── */
.signup2026__verify-row {
    display: flex;
    gap: 8px;
    width: 100%;
}

.signup2026__verify-row .signup2026__input {
    flex: 1 1;
    min-width: 0;
}

.signup2026__verify-btn {
    flex-shrink: 0;
    padding: 0 16px;
    min-height: 42px;
    background: var(--fg-bg-litepp);
    border: 0;
    border-radius: 8px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    color: var(--fg-button-hover);
    cursor: pointer;
    transition: background 160ms ease;
}

.signup2026__verify-btn:hover:not(:disabled) {
    background: #d8dcec;
}

.signup2026__verify-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ─── 제출/액션 버튼 (인증요청, 다음) ─── */
.signup2026__submit {
    width: 100%;
    min-height: 44px;
    padding: 12px;
    background: var(--fg-button);
    border: 0;
    border-radius: 8px;
    color: #fff;
    font-family: inherit;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    transition: background 160ms ease;
}

.signup2026__submit:hover:not(:disabled) {
    background: var(--fg-button-hover);
}

.signup2026__submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* ─── 인증 완료 텍스트 ─── */
.signup2026__complete-text {
    margin: 0;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    color: var(--fg-anti-red, #ff1500);
}

/* ─── 로그인 링크 ─── */
.signup2026__login-link {
    margin: 8px 0 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 14px;
    line-height: 1.4;
    color: var(--fg-text-basic);
    text-align: center;
}

.signup2026__login-link a {
    color: var(--fg-link);
    text-decoration: underline;
    font-weight: 600;
    transition: color 160ms ease;
}

.signup2026__login-link a:hover {
    color: var(--fg-link-hover);
}

/* ============================================================
   약관 동의 단계 (Figma node 2045:12597)
   ============================================================ */
.signup2026__section--terms {
    gap: 20px;
}

.signup2026__agree-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.signup2026__agree-row {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
}

.signup2026__agree-row--all {
    justify-content: flex-start;
}

.signup2026__agree-row--two-line {
    align-items: center;
}

.signup2026__agree-check {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    padding: 0;
    background: #fff;
    border: 2px solid var(--fg-text-gray);
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 160ms ease, border-color 160ms ease;
    box-sizing: border-box;
}

.signup2026__agree-check svg path {
    stroke: var(--fg-text-gray);
    transition: stroke 160ms ease;
}

.signup2026__agree-check--active {
    background: var(--fg-button-hover);
    border-color: var(--fg-button-hover);
}

.signup2026__agree-check--active svg path {
    stroke: #ffffff;
}

.signup2026__agree-tag {
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    color: var(--fg-text-gray);
}

.signup2026__agree-tag--required {
    color: var(--fg-anti-red, #ff1500);
}

.signup2026__agree-text {
    flex: 0 0 auto;
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
    color: var(--fg-text-basic);
    white-space: nowrap;
}

.signup2026__agree-text--all {
    flex: 1 1 auto;
}

.signup2026__agree-text-group {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
}

.signup2026__agree-text-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.signup2026__agree-subtext {
    font-size: 14px;
    font-weight: 400;
    line-height: 1;
    color: var(--fg-text-gray);
}

.signup2026__agree-view {
    margin-left: auto;
    flex-shrink: 0;
    padding: 0;
    background: transparent;
    border: 0;
    font-family: inherit;
    font-size: 15px;
    font-weight: 400;
    line-height: 28px;
    color: var(--fg-link, #2c95f8);
    text-decoration: underline;
    cursor: pointer;
    transition: color 160ms ease;
}

.signup2026__agree-view:hover {
    color: var(--fg-link-hover, #1a7ad6);
}

/* ============================================================
   이용약관 / 개인정보처리방침 모달 (기존 유지)
   ============================================================ */
.terms-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
}

.terms-modal {
    background: #fff;
    border-radius: 12px;
    width: 100%;
    max-width: 640px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.terms-modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid var(--fg-line);
    flex-shrink: 0;
}

.terms-modal__title {
    font-size: 18px;
    font-weight: 700;
    color: var(--fg-text-basic);
    margin: 0;
}

.terms-modal__close {
    width: 32px;
    height: 32px;
    border: none;
    background: var(--gray-100);
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--fg-text-gray);
    transition: background-color 160ms ease;
}

.terms-modal__close:hover {
    background: var(--gray-200);
}

.terms-modal__close svg {
    width: 18px;
    height: 18px;
}

.terms-modal__body {
    padding: 24px;
    overflow-y: auto;
    flex: 1 1;
}

.terms-modal__body h3 {
    font-size: 15px;
    font-weight: 700;
    color: var(--fg-text-basic);
    margin: 24px 0 8px 0;
}

.terms-modal__body h3:first-child {
    margin-top: 0;
}

.terms-modal__body p {
    font-size: 13px;
    color: var(--fg-text-basic);
    line-height: 1.7;
    margin: 0 0 8px 0;
}

.terms-modal__body ul {
    margin: 0 0 8px 0;
    padding-left: 20px;
}

.terms-modal__body li {
    font-size: 13px;
    color: var(--fg-text-basic);
    line-height: 1.7;
    margin-bottom: 4px;
}

.terms-modal__body li strong {
    color: var(--fg-text-basic);
}

.terms-modal__footer-text {
    margin: 0;
    padding: 16px 24px;
    border-top: 1px solid var(--fg-line);
    font-size: 12px;
    color: var(--fg-text-gray);
    text-align: center;
    flex-shrink: 0;
}

/* ============================================================
   처리 중 로딩 모달
   ============================================================ */
.signup2026__loading-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1100;
    padding: 24px;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
}

.signup2026__loading-modal {
    background: #fff;
    border-radius: 16px;
    padding: 32px 28px;
    width: 100%;
    max-width: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    text-align: center;
}

.signup2026__loading-spinner {
    width: 44px;
    height: 44px;
    border: 4px solid var(--fg-bg-litepp, #e8eaf5);
    border-top-color: var(--fg-button, #978cca);
    border-radius: 50%;
    animation: spin 0.9s linear infinite;
}

.signup2026__loading-title {
    margin: 4px 0 0;
    font-size: 16px;
    font-weight: 700;
    color: var(--fg-text-basic);
    line-height: 1.3;
}

.signup2026__loading-desc {
    margin: 0;
    font-size: 13px;
    color: var(--fg-text-gray);
    line-height: 1.5;
}

/* 스피너 애니메이션 (BC) */
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/css/UserSignup.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uDAAuD;IACvD,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,SAAO;AACX;;AAEA,8BAA8B;AAC9B;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,SAAS;IACT,oBAAoB;AACxB;;AAEA,0BAA0B;AAC1B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,sDAAsD;AAC1D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;IACtB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,SAAS;IACT,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;iEAEiE;AACjE;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;IAC9B,0BAA0B;IAC1B,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;iEAEiE;AACjE;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;iEAEiE;AACjE;IACI,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,2CAA2C;IAC3C,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC","sourcesContent":["/* ============================================================\n   UserSignup 2026 — Figma node 2034:12383 기반 신규 디자인\n   모바일 360px 단일 컬럼, login2026 시스템과 동일한 토큰 사용\n   ============================================================ */\n\n.signup2026 {\n    min-height: 100vh;\n    background: #fff;\n    font-family: var(--font-sans, 'Pretendard', sans-serif);\n    color: var(--fg-text-basic);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 48px 24px 32px;\n    box-sizing: border-box;\n}\n\n.signup2026__main {\n    width: 100%;\n    max-width: 360px;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 24px;\n    flex: 1;\n}\n\n/* 약관 동의 단계: 폼을 화면 세로 중앙에 배치 */\n.signup2026--centered {\n    justify-content: center;\n}\n\n.signup2026--centered .signup2026__main {\n    flex: 0 1 auto;\n}\n\n.signup2026__form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n/* ─── 섹션 공통 ─── */\n.signup2026__section {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n\n.signup2026__section--complete {\n    gap: 20px;\n    align-items: stretch;\n}\n\n/* ─── 브랜드 로고 + 워드마크 ─── */\n.signup2026__brand {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    height: 42px;\n    text-decoration: none;\n    color: inherit;\n    cursor: pointer;\n    transition: opacity var(--transition-fast, 0.15s ease);\n}\n\n.signup2026__brand:hover {\n    opacity: 0.85;\n}\n\n.signup2026__brand-logo {\n    width: 38px;\n    height: 42px;\n    object-fit: contain;\n    display: block;\n}\n\n.signup2026__brand-text {\n    font-family: 'Pretendard', sans-serif;\n    font-size: 26px;\n    font-weight: 800;\n    color: var(--fg-text-basic);\n    letter-spacing: -0.6px;\n    line-height: 1;\n}\n\n/* ─── 섹션 타이틀 ─── */\n.signup2026__title {\n    margin: 0;\n    font-size: 28px;\n    font-weight: 600;\n    line-height: 40px;\n    letter-spacing: -0.2px;\n    color: var(--fg-text-basic);\n}\n\n.signup2026__subtitle {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n}\n\n/* ─── 필드 ─── */\n.signup2026__field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 100%;\n}\n\n.signup2026__field--compact {\n    gap: 4px;\n}\n\n.signup2026__field-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1;\n    color: var(--fg-text-basic);\n}\n\n.signup2026__field-label svg {\n    flex-shrink: 0;\n}\n\n.signup2026__input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 8px 12px;\n    background: #fff;\n    border: 1px solid var(--fg-line);\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 16px;\n    line-height: 26px;\n    color: var(--fg-text-basic);\n    outline: none;\n    transition: border-color 160ms ease;\n}\n\n.signup2026__input::placeholder {\n    color: var(--fg-text-gray);\n}\n\n.signup2026__input:focus {\n    border-color: var(--fg-button);\n}\n\n.signup2026__input:disabled {\n    background: #fafafa;\n    color: var(--fg-text-gray);\n    cursor: not-allowed;\n}\n\n.signup2026__input--error {\n    border-color: var(--fg-anti-red, #ff1500);\n}\n\n.signup2026__field-error {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.2;\n    color: var(--fg-anti-red, #ff1500);\n}\n\n.signup2026__field-hint {\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.2;\n    color: var(--fg-text-gray);\n}\n\n.signup2026__field-hint--ok {\n    color: var(--fg-button-hover);\n}\n\n/* ─── 셀렉트 ─── */\n.signup2026__select-wrap {\n    position: relative;\n    width: 100%;\n}\n\n.signup2026__select {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 8px 36px 8px 12px;\n    background: #fff;\n    border: 1px solid var(--fg-line);\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 16px;\n    line-height: 26px;\n    color: var(--fg-text-basic);\n    outline: none;\n    appearance: none;\n    cursor: pointer;\n    transition: border-color 160ms ease;\n}\n\n.signup2026__select--placeholder {\n    color: var(--fg-text-gray);\n}\n\n.signup2026__select:focus {\n    border-color: var(--fg-button);\n}\n\n.signup2026__select-icon {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    display: inline-flex;\n    pointer-events: none;\n}\n\n/* ─── 성별 / 내외국인 토글 그룹 ─── */\n.signup2026__toggle-row {\n    display: flex;\n    gap: 12px;\n    width: 100%;\n}\n\n.signup2026__toggle-group {\n    display: flex;\n    gap: 4px;\n    flex: 1;\n    min-width: 0;\n}\n\n.signup2026__toggle {\n    flex: 1;\n    min-width: 0;\n    padding: 8px;\n    background: #fff;\n    border: 1px solid var(--fg-line);\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--fg-text-gray);\n    cursor: pointer;\n    transition: border-color 160ms ease, color 160ms ease, background 160ms ease;\n}\n\n.signup2026__toggle:hover:not(:disabled) {\n    border-color: var(--fg-text-basic);\n}\n\n.signup2026__toggle--active {\n    border-color: var(--fg-text-basic);\n    color: var(--fg-text-basic);\n    font-weight: 600;\n}\n\n/* ─── 약관 동의 박스 ─── */\n.signup2026__terms-box {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    width: 100%;\n    padding: 0;\n    background: #fff;\n}\n\n.signup2026__check {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    flex-shrink: 0;\n    cursor: pointer;\n    user-select: none;\n}\n\n.signup2026__check input {\n    position: absolute;\n    opacity: 0;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    cursor: pointer;\n}\n\n.signup2026__check-box {\n    width: 28px;\n    height: 28px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #fff;\n    border: 2px solid var(--fg-text-gray);\n    border-radius: 50%;\n    transition: background 160ms ease, border-color 160ms ease;\n    box-sizing: border-box;\n}\n\n.signup2026__check-box svg {\n    opacity: 0;\n    transition: opacity 160ms ease;\n}\n\n.signup2026__check input:checked + .signup2026__check-box {\n    background: var(--fg-button);\n    border-color: var(--fg-button);\n}\n\n.signup2026__check input:checked + .signup2026__check-box svg {\n    opacity: 1;\n}\n\n.signup2026__terms-content {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding-top: 6px;\n}\n\n.signup2026__terms-title {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--fg-text-basic);\n    line-height: 1;\n}\n\n.signup2026__terms-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    width: auto;\n}\n\n.signup2026__terms-list button {\n    background: transparent;\n    border: 0;\n    padding: 0;\n    width: auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-family: inherit;\n    font-size: 14px;\n    line-height: 1.2;\n    color: var(--fg-text-gray);\n    cursor: pointer;\n    transition: color 160ms ease;\n    white-space: nowrap;\n}\n\n.signup2026__terms-list button > span {\n    white-space: nowrap;\n}\n\n.signup2026__terms-list button:hover {\n    color: var(--fg-text-basic);\n}\n\n.signup2026__terms-list button svg {\n    flex-shrink: 0;\n}\n\n/* ─── 인증번호 입력 행 ─── */\n.signup2026__verify-row {\n    display: flex;\n    gap: 8px;\n    width: 100%;\n}\n\n.signup2026__verify-row .signup2026__input {\n    flex: 1;\n    min-width: 0;\n}\n\n.signup2026__verify-btn {\n    flex-shrink: 0;\n    padding: 0 16px;\n    min-height: 42px;\n    background: var(--fg-bg-litepp);\n    border: 0;\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--fg-button-hover);\n    cursor: pointer;\n    transition: background 160ms ease;\n}\n\n.signup2026__verify-btn:hover:not(:disabled) {\n    background: #d8dcec;\n}\n\n.signup2026__verify-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* ─── 제출/액션 버튼 (인증요청, 다음) ─── */\n.signup2026__submit {\n    width: 100%;\n    min-height: 44px;\n    padding: 12px;\n    background: var(--fg-button);\n    border: 0;\n    border-radius: 8px;\n    color: #fff;\n    font-family: inherit;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 160ms ease;\n}\n\n.signup2026__submit:hover:not(:disabled) {\n    background: var(--fg-button-hover);\n}\n\n.signup2026__submit:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* ─── 인증 완료 텍스트 ─── */\n.signup2026__complete-text {\n    margin: 0;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.2;\n    color: var(--fg-anti-red, #ff1500);\n}\n\n/* ─── 로그인 링크 ─── */\n.signup2026__login-link {\n    margin: 8px 0 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    font-size: 14px;\n    line-height: 1.4;\n    color: var(--fg-text-basic);\n    text-align: center;\n}\n\n.signup2026__login-link a {\n    color: var(--fg-link);\n    text-decoration: underline;\n    font-weight: 600;\n    transition: color 160ms ease;\n}\n\n.signup2026__login-link a:hover {\n    color: var(--fg-link-hover);\n}\n\n/* ============================================================\n   약관 동의 단계 (Figma node 2045:12597)\n   ============================================================ */\n.signup2026__section--terms {\n    gap: 20px;\n}\n\n.signup2026__agree-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n\n.signup2026__agree-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n}\n\n.signup2026__agree-row--all {\n    justify-content: flex-start;\n}\n\n.signup2026__agree-row--two-line {\n    align-items: center;\n}\n\n.signup2026__agree-check {\n    flex-shrink: 0;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    background: #fff;\n    border: 2px solid var(--fg-text-gray);\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background 160ms ease, border-color 160ms ease;\n    box-sizing: border-box;\n}\n\n.signup2026__agree-check svg path {\n    stroke: var(--fg-text-gray);\n    transition: stroke 160ms ease;\n}\n\n.signup2026__agree-check--active {\n    background: var(--fg-button-hover);\n    border-color: var(--fg-button-hover);\n}\n\n.signup2026__agree-check--active svg path {\n    stroke: #ffffff;\n}\n\n.signup2026__agree-tag {\n    flex-shrink: 0;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1;\n    color: var(--fg-text-gray);\n}\n\n.signup2026__agree-tag--required {\n    color: var(--fg-anti-red, #ff1500);\n}\n\n.signup2026__agree-text {\n    flex: 0 0 auto;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1;\n    color: var(--fg-text-basic);\n    white-space: nowrap;\n}\n\n.signup2026__agree-text--all {\n    flex: 1 1 auto;\n}\n\n.signup2026__agree-text-group {\n    flex: 1 1 auto;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    justify-content: center;\n}\n\n.signup2026__agree-text-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.signup2026__agree-subtext {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1;\n    color: var(--fg-text-gray);\n}\n\n.signup2026__agree-view {\n    margin-left: auto;\n    flex-shrink: 0;\n    padding: 0;\n    background: transparent;\n    border: 0;\n    font-family: inherit;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 28px;\n    color: var(--fg-link, #2c95f8);\n    text-decoration: underline;\n    cursor: pointer;\n    transition: color 160ms ease;\n}\n\n.signup2026__agree-view:hover {\n    color: var(--fg-link-hover, #1a7ad6);\n}\n\n/* ============================================================\n   이용약관 / 개인정보처리방침 모달 (기존 유지)\n   ============================================================ */\n.terms-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 20px;\n}\n\n.terms-modal {\n    background: #fff;\n    border-radius: 12px;\n    width: 100%;\n    max-width: 640px;\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n}\n\n.terms-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 24px;\n    border-bottom: 1px solid var(--fg-line);\n    flex-shrink: 0;\n}\n\n.terms-modal__title {\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.terms-modal__close {\n    width: 32px;\n    height: 32px;\n    border: none;\n    background: var(--gray-100);\n    border-radius: 6px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--fg-text-gray);\n    transition: background-color 160ms ease;\n}\n\n.terms-modal__close:hover {\n    background: var(--gray-200);\n}\n\n.terms-modal__close svg {\n    width: 18px;\n    height: 18px;\n}\n\n.terms-modal__body {\n    padding: 24px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.terms-modal__body h3 {\n    font-size: 15px;\n    font-weight: 700;\n    color: var(--fg-text-basic);\n    margin: 24px 0 8px 0;\n}\n\n.terms-modal__body h3:first-child {\n    margin-top: 0;\n}\n\n.terms-modal__body p {\n    font-size: 13px;\n    color: var(--fg-text-basic);\n    line-height: 1.7;\n    margin: 0 0 8px 0;\n}\n\n.terms-modal__body ul {\n    margin: 0 0 8px 0;\n    padding-left: 20px;\n}\n\n.terms-modal__body li {\n    font-size: 13px;\n    color: var(--fg-text-basic);\n    line-height: 1.7;\n    margin-bottom: 4px;\n}\n\n.terms-modal__body li strong {\n    color: var(--fg-text-basic);\n}\n\n.terms-modal__footer-text {\n    margin: 0;\n    padding: 16px 24px;\n    border-top: 1px solid var(--fg-line);\n    font-size: 12px;\n    color: var(--fg-text-gray);\n    text-align: center;\n    flex-shrink: 0;\n}\n\n/* ============================================================\n   처리 중 로딩 모달\n   ============================================================ */\n.signup2026__loading-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1100;\n    padding: 24px;\n    backdrop-filter: blur(2px);\n    -webkit-backdrop-filter: blur(2px);\n}\n\n.signup2026__loading-modal {\n    background: #fff;\n    border-radius: 16px;\n    padding: 32px 28px;\n    width: 100%;\n    max-width: 320px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 14px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n    text-align: center;\n}\n\n.signup2026__loading-spinner {\n    width: 44px;\n    height: 44px;\n    border: 4px solid var(--fg-bg-litepp, #e8eaf5);\n    border-top-color: var(--fg-button, #978cca);\n    border-radius: 50%;\n    animation: spin 0.9s linear infinite;\n}\n\n.signup2026__loading-title {\n    margin: 4px 0 0;\n    font-size: 16px;\n    font-weight: 700;\n    color: var(--fg-text-basic);\n    line-height: 1.3;\n}\n\n.signup2026__loading-desc {\n    margin: 0;\n    font-size: 13px;\n    color: var(--fg-text-gray);\n    line-height: 1.5;\n}\n\n/* 스피너 애니메이션 (BC) */\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
